import { render, staticRenderFns } from "./classRoster.vue?vue&type=template&id=4eed6d58&scoped=true&"
import script from "./classRoster.vue?vue&type=script&lang=js&"
export * from "./classRoster.vue?vue&type=script&lang=js&"
import style0 from "./classRoster.vue?vue&type=style&index=0&id=4eed6d58&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eed6d58",
  null
  
)

export default component.exports